"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTimeOnly = exports.isTimeOnly = void 0;
const core_1 = require("@js-joda/core");
const class_validator_1 = require("class-validator");
const isString_1 = __importDefault(require("lodash/isString"));
const merge_1 = __importDefault(require("lodash/merge"));
const Exists_1 = require("../common/Exists");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function isTimeOnly(value, args, constraints) {
    constraints = (0, merge_1.default)({}, constraints);
    const existsResults = await (0, Exists_1.exists)(value, args, constraints);
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    if ((0, isString_1.default)(value)) {
        const isTime = (0, class_validator_1.isMilitaryTime)(value);
        if (!isTime) {
            return { pass: false, message: "should be a valid time only reprensentation" };
        }
    }
    else if (!(value instanceof core_1.LocalTime)) {
        return { pass: false, message: "should be of the type string or LocalTime" };
    }
    return { pass: true };
}
exports.isTimeOnly = isTimeOnly;
/**
 * Validates that this value can be parsed into a local date with no time component
 * Uses `DateUtils.toZonedDateTime` under the hood
 */
function IsTimeOnly(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsTimeOnly",
        defaultMessage: `should be a valid time`,
        options,
        constraints,
        validateFn: isTimeOnly,
    });
}
exports.IsTimeOnly = IsTimeOnly;
//# sourceMappingURL=IsTimeOnly.js.map